export function configureCapacitorDocumentBase(runtimeConfig, documentRef) {
  if (!runtimeConfig?.capacitorApp || !runtimeConfig?.serviceOrigin || !documentRef?.head) {
    return '';
  }
  const serviceOrigin = String(runtimeConfig.serviceOrigin).replace(/\/$/, '');
  let base = documentRef.querySelector('base[data-jc-capacitor-base]');
  if (!base) {
    base = documentRef.createElement('base');
    base.dataset.jcCapacitorBase = 'true';
    documentRef.head.prepend(base);
  }
  base.href = `${serviceOrigin}/`;
  return base.href;
}
